<script setup lang="ts">
import { computed } from "vue";

import { useSearchMenuStore } from "@/store/search/searchMenu";

import StatusItemTooltip from "../tooltips/StatusItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";
import SelectStatusClass from "./internal/SelectStatusClass.vue";

const selection = computed(() => useSearchMenuStore().selectedStatusItems);
</script>

<template>
  <SearchDropdown
    name="status"
    icon="general/status"
    label-key="general.statuses"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <StatusItemTooltip />
    </template>
    <SelectStatusClass />
  </SearchDropdown>
</template>
